// All static data for the frontend-only app

export const WHATSAPP_NUMBER = "919810134293";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const EMAIL = "jmeducarepvtltd@gmail.com";
export const PHONE = "+91 98101 34293";

export const COURSES = [
  {
    id: "sat-math",
    name: "SAT Mathematics",
    category: "Standardized Tests",
    description: "Comprehensive SAT Math preparation designed to maximize your score on the digital SAT. Master problem-solving strategies and time management techniques.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Score improvement of 100-200+ points", "Digital SAT format mastery", "Adaptive test strategies"],
    topics: [
      "Heart of Algebra - Linear equations, inequalities, and systems",
      "Problem Solving & Data Analysis - Ratios, percentages, and data interpretation",
      "Passport to Advanced Math - Quadratics, polynomials, and complex equations",
      "Additional Topics - Geometry, trigonometry, and complex numbers"
    ],
    features: [
      "Full syllabus coverage aligned with College Board guidelines",
      "Unlimited practice tests with detailed analysis",
      "1-on-1 doubt clearing sessions",
      "Comprehensive study materials and formula sheets",
      "Score prediction and progress tracking"
    ],
    ideal_for: "Students who want to achieve 750+ in SAT Math"
  },
  {
    id: "gre-quant",
    name: "GRE Quantitative Reasoning",
    category: "Standardized Tests",
    description: "Master GRE Quantitative Reasoning with expert strategies for both Quantitative Comparison and Problem Solving questions.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Target 165+ Quant score", "Computer-adaptive test strategies", "Time management mastery"],
    topics: [
      "Arithmetic - Number properties, fractions, decimals, and percentages",
      "Algebra - Equations, inequalities, and functions",
      "Geometry - Lines, angles, triangles, circles, and coordinate geometry",
      "Data Analysis - Statistics, probability, and data interpretation"
    ],
    features: [
      "Topic-wise concept building and practice",
      "Quantitative Comparison specific strategies",
      "Data Interpretation techniques",
      "Full-length mock tests with ETS-style questions",
      "Performance analytics and weak area identification"
    ],
    ideal_for: "Graduate school aspirants targeting top programs requiring strong quantitative skills"
  },
  {
    id: "gmat-quant",
    name: "GMAT Quantitative Section",
    category: "Standardized Tests",
    description: "Excel in GMAT Quantitative Section with focus on Problem Solving and Data Sufficiency. Learn the strategic approach that top scorers use.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Target Q49+ score", "Data Sufficiency mastery", "700+ overall GMAT strategies"],
    topics: [
      "Problem Solving - Arithmetic, algebra, geometry, and word problems",
      "Data Sufficiency - Unique GMAT question type strategies",
      "Number Properties - Divisibility, primes, and remainders",
      "Statistics & Probability - Mean, median, mode, and combinations"
    ],
    features: [
      "Data Sufficiency question-type mastery",
      "Problem Solving techniques and shortcuts",
      "Time management for 62-minute section",
      "Official GMAT practice questions",
      "Score improvement tracking"
    ],
    ideal_for: "MBA aspirants targeting top B-schools like ISB, IIMs, and international programs"
  },
  {
    id: "ap-calc-ab",
    name: "AP Calculus AB",
    category: "Advanced Placement",
    description: "Complete AP Calculus AB preparation covering limits, derivatives, and integrals. Designed to help you earn college credit with a score of 4 or 5.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Score 4 or 5 guarantee approach", "College credit preparation", "Strong calculus foundation"],
    topics: [
      "Limits and Continuity - Understanding limits, continuity, and asymptotes",
      "Differentiation - Rules, applications, and related rates",
      "Integration - Techniques, definite integrals, and FTC",
      "Applications - Area, volume, and differential equations"
    ],
    features: [
      "Complete AP curriculum coverage",
      "Free Response Question (FRQ) practice",
      "Multiple Choice strategy sessions",
      "Past AP exam analysis",
      "Graphing calculator techniques"
    ],
    ideal_for: "High school students seeking college credit and strong math foundation"
  },
  {
    id: "ap-calc-bc",
    name: "AP Calculus BC",
    category: "Advanced Placement",
    description: "Advanced AP Calculus BC course covering all AB topics plus sequences, series, parametric, polar, and vector functions.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Comprehensive BC curriculum", "Series and sequences mastery", "Top score preparation"],
    topics: [
      "All AP Calculus AB Topics - Limits, derivatives, and integrals",
      "Sequences and Series - Convergence tests, Taylor and Maclaurin series",
      "Parametric Equations - Derivatives and integrals in parametric form",
      "Polar Functions - Graphing, area, and arc length",
      "Vector-Valued Functions - Motion in plane"
    ],
    features: [
      "Complete BC syllabus including all AB topics",
      "Series convergence test mastery",
      "Parametric and polar function expertise",
      "College-level preparation",
      "Comprehensive FRQ practice"
    ],
    ideal_for: "Advanced students aiming for engineering, physics, or mathematics majors"
  },
  {
    id: "ib-math-aa-hl",
    name: "IB Mathematics AA HL",
    category: "International Baccalaureate",
    description: "IB Mathematics: Analysis and Approaches Higher Level - rigorous preparation for students pursuing mathematics-intensive university courses.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Score 6 or 7 target", "University preparation focus", "IA guidance included"],
    topics: [
      "Number and Algebra - Sequences, series, and proof",
      "Functions - Properties, transformations, and modeling",
      "Geometry and Trigonometry - 3D geometry and trig identities",
      "Statistics and Probability - Distributions and hypothesis testing",
      "Calculus - Advanced differentiation and integration"
    ],
    features: [
      "Complete HL syllabus coverage",
      "Internal Assessment (IA) topic selection and guidance",
      "Paper 1, 2, and 3 preparation",
      "Past paper practice with examiner insights",
      "Exam technique and time management"
    ],
    ideal_for: "IB students planning to study engineering, physics, or pure mathematics at university"
  },
  {
    id: "ib-math-aa-sl",
    name: "IB Mathematics AA SL",
    category: "International Baccalaureate",
    description: "IB Mathematics: Analysis and Approaches Standard Level - solid mathematical foundation with emphasis on analytical thinking.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Strong conceptual foundation", "Score 6+ target", "IA support included"],
    topics: [
      "Number and Algebra - Arithmetic, geometric sequences, and logarithms",
      "Functions - Linear, quadratic, and exponential functions",
      "Geometry and Trigonometry - Sine, cosine rules and identities",
      "Statistics and Probability - Descriptive statistics and probability",
      "Calculus - Basic differentiation and integration"
    ],
    features: [
      "Complete SL curriculum coverage",
      "IA guidance from topic to final submission",
      "Paper 1 and 2 exam strategies",
      "Formula booklet mastery",
      "Regular assessments and feedback"
    ],
    ideal_for: "IB students needing solid math skills for sciences, economics, or business"
  },
  {
    id: "ib-math-ai-hl",
    name: "IB Mathematics AI HL",
    category: "International Baccalaureate",
    description: "IB Mathematics: Applications and Interpretation HL - focus on real-world applications, statistics, and mathematical modeling.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Real-world applications focus", "Technology integration", "Statistical analysis mastery"],
    topics: [
      "Number and Algebra - Financial mathematics and modeling",
      "Functions - Modeling with various function types",
      "Geometry and Trigonometry - Voronoi diagrams and vectors",
      "Statistics and Probability - Advanced statistics and distributions",
      "Calculus - Optimization and kinematics"
    ],
    features: [
      "GDC (Graphing Calculator) mastery",
      "Statistical analysis techniques",
      "Mathematical modeling projects",
      "IA exploration guidance",
      "Real-world problem solving"
    ],
    ideal_for: "Students interested in social sciences, psychology, business, or design"
  },
  {
    id: "ib-math-ai-sl",
    name: "IB Mathematics AI SL",
    category: "International Baccalaureate",
    description: "IB Mathematics: Applications and Interpretation SL - practical mathematics with emphasis on technology and real-world applications.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Practical math skills", "Calculator-based learning", "Application focused"],
    topics: [
      "Number and Algebra - Percentages, loans, and investments",
      "Functions - Linear and exponential models",
      "Geometry and Trigonometry - Practical applications",
      "Statistics and Probability - Data analysis and interpretation",
      "Calculus - Basic concepts and applications"
    ],
    features: [
      "Technology-integrated learning",
      "Real-life application problems",
      "IA support and guidance",
      "Exam preparation strategies",
      "Statistical software familiarity"
    ],
    ideal_for: "Students who prefer practical, application-based mathematics"
  },
  {
    id: "cbse-9-10",
    name: "CBSE Mathematics (9-10)",
    category: "Indian Boards",
    description: "Complete CBSE Mathematics coaching for Classes 9 and 10, building strong foundations for board exams and competitive entrance tests.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Board exam excellence", "NTSE/Olympiad preparation", "Strong foundation building"],
    topics: [
      "Number Systems - Real numbers and polynomials",
      "Algebra - Linear equations, quadratic equations",
      "Coordinate Geometry - Distance, section formula, area",
      "Geometry - Triangles, circles, constructions",
      "Trigonometry - Ratios, identities, and applications",
      "Statistics and Probability - Data handling and probability"
    ],
    features: [
      "NCERT + exemplar problem coverage",
      "Board exam pattern practice",
      "HOTS (Higher Order Thinking) questions",
      "Weekly tests and assessments",
      "Doubt clearing sessions"
    ],
    ideal_for: "CBSE students aiming for 95%+ in board exams"
  },
  {
    id: "cbse-11-12",
    name: "CBSE Mathematics (11-12)",
    category: "Indian Boards",
    description: "Advanced CBSE Mathematics for Classes 11 and 12, with focus on board exams and JEE/entrance exam foundation.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["Board + JEE foundation", "Complete syllabus mastery", "Concept clarity focus"],
    topics: [
      "Sets, Relations and Functions - Foundation concepts",
      "Algebra - Complex numbers, sequences, permutations",
      "Coordinate Geometry - Straight lines, conics",
      "Calculus - Limits, differentiation, integration",
      "Vectors and 3D Geometry - Vector algebra and 3D",
      "Linear Programming and Probability"
    ],
    features: [
      "Complete NCERT coverage with advanced problems",
      "Previous year board papers analysis",
      "Sample paper practice",
      "JEE Main level problem exposure",
      "Regular progress assessments"
    ],
    ideal_for: "Class 11-12 students preparing for boards and engineering entrances"
  },
  {
    id: "isc-9-10",
    name: "ISC Mathematics (9-10)",
    category: "Indian Boards",
    description: "Comprehensive ISC Mathematics coaching for Classes 9 and 10 with emphasis on conceptual understanding and application skills.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["ISC board excellence", "Strong analytical skills", "Concept-based learning"],
    topics: [
      "Commercial Mathematics - Profit, loss, banking",
      "Algebra - Polynomials, factorization, equations",
      "Geometry - Similarity, circles, constructions",
      "Trigonometry - Identities and applications",
      "Statistics - Mean, median, mode, graphical representation",
      "Coordinate Geometry - Basic concepts and graphs"
    ],
    features: [
      "ISC syllabus focused preparation",
      "Application-based problem solving",
      "Board exam pattern practice",
      "Concept clarity sessions",
      "Regular homework and feedback"
    ],
    ideal_for: "ISC students aiming for distinction in mathematics"
  },
  {
    id: "isc-11-12",
    name: "ISC Mathematics (11-12)",
    category: "Indian Boards",
    description: "Advanced ISC Mathematics preparation for Classes 11 and 12, ensuring excellence in board exams and competitive preparations.",
    price: 2000,
    duration: "Per Hour",
    highlights: ["ISC board mastery", "Competitive exam ready", "Advanced problem solving"],
    topics: [
      "Algebra - Complex numbers, quadratics, matrices",
      "Calculus - Differentiation, integration, applications",
      "Probability - Advanced probability concepts",
      "Vectors - 2D and 3D applications",
      "Coordinate Geometry - Conics and 3D geometry",
      "Statistics - Correlation and regression"
    ],
    features: [
      "Complete ISC syllabus coverage",
      "Previous years' solved papers",
      "Section-wise practice tests",
      "Doubt clearing and revision sessions",
      "Exam strategy and time management"
    ],
    ideal_for: "ISC students targeting 95%+ and competitive exam preparation"
  }
];

export const TESTIMONIALS = [
  { id: "t1", name: "Priya Sharma", course: "SAT Mathematics", rating: 5, text: "Anand Sir's teaching methodology is exceptional. I improved my SAT Math score from 650 to 780 in just 2 months!" },
  { id: "t2", name: "Rahul Mehta", course: "IB Math AA HL", rating: 5, text: "The personalized attention and clear explanations helped me score a 7 in IB Math HL. Highly recommended!" },
  { id: "t3", name: "Ananya Gupta", course: "AP Calculus BC", rating: 5, text: "Got a 5 on my AP Calc BC exam! Sir's problem-solving approach made complex topics easy to understand." },
  { id: "t4", name: "Vikram Singh", course: "GRE Quantitative", rating: 5, text: "Scored 170 in GRE Quant! The strategies and practice problems were incredibly helpful." },
  { id: "t5", name: "Neha Patel", course: "CBSE Math (11-12)", rating: 5, text: "From 70% to 95% in board exams! Sir's dedication and patience made all the difference." }
];

export const FAQS = [
  { id: "f1", question: "How are the classes conducted?", answer: "Classes are conducted one-on-one, either online via Zoom/Google Meet or offline at our study center. Each session is 60-90 minutes long.", category: "Classes" },
  { id: "f2", question: "What is the class schedule flexibility?", answer: "We offer flexible scheduling to accommodate students' school timings. Classes can be scheduled on weekdays or weekends based on mutual availability.", category: "Schedule" },
  { id: "f3", question: "How do I track my progress?", answer: "Students get access to a personalized dashboard where they can track topics covered, view upcoming sessions, and monitor their progress through regular assessments.", category: "Progress" },
  { id: "f4", question: "What study materials are provided?", answer: "Comprehensive study materials including notes, practice problems, past papers, and video recordings of concepts are provided as part of the course.", category: "Materials" },
  { id: "f5", question: "Can I take a demo class before enrolling?", answer: "Yes! We offer a free demo class so you can experience our teaching methodology before making a commitment.", category: "Demo" },
  { id: "f6", question: "What is the refund policy?", answer: "We offer a full refund within the first week if you're not satisfied. After that, a pro-rated refund is available based on classes attended.", category: "Payment" },
  { id: "f7", question: "How do I make payments?", answer: "We accept bank transfers, UPI, and card payments. Payment can be made monthly or for the full course duration with a discount.", category: "Payment" },
  { id: "f8", question: "What if I miss a class?", answer: "Missed classes can be rescheduled within the same week. We also provide recordings of online sessions when requested in advance.", category: "Schedule" }
];

export const RESOURCES = [
  { id: "r1", title: "SAT Math Formula Sheet", description: "Complete formula reference sheet for SAT Mathematics — covers algebra, geometry, trigonometry, and data analysis.", category: "Formula Sheets", file_url: null, file_type: "pdf" },
  { id: "r2", title: "IB Math AA HL Revision Notes", description: "Comprehensive revision notes covering all topics for IB Mathematics Analysis & Approaches Higher Level.", category: "Revision Notes", file_url: null, file_type: "pdf" },
  { id: "r3", title: "AP Calculus BC Practice Problems", description: "50+ practice problems with detailed solutions for AP Calculus BC exam preparation.", category: "Practice Problems", file_url: null, file_type: "pdf" },
  { id: "r4", title: "GRE Quant Strategy Guide", description: "Essential strategies and shortcuts for GRE Quantitative Reasoning section — score 165+.", category: "Strategy Guides", file_url: null, file_type: "pdf" },
  { id: "r5", title: "CBSE Class 12 Sample Papers", description: "Latest CBSE board exam sample papers with marking schemes and solutions.", category: "Sample Papers", file_url: null, file_type: "pdf" }
];

export const OFFICE_HOURS = {
  weekdays: "9:00 AM - 7:00 PM IST",
  saturday: "10:00 AM - 4:00 PM IST",
  sunday: "Closed"
};

export const MEETING_LINK = "https://us06web.zoom.us/j/3453765854?pwd=YXhzSHpMdFh2Sy9CcWcvbFVSamQwQT09";

// Helper to open WhatsApp with a pre-filled message
export const openWhatsApp = (message = "Hi, I am interested in mathematics tuition. Please share more details.") => {
  window.open(`${WHATSAPP_URL}?text=${encodeURIComponent(message)}`, '_blank');
};

// Helper to open WhatsApp with booking details
export const openWhatsAppBooking = ({ name, course, date, time, message }) => {
  const parts = [`Hi, I would like to book a demo class.`];
  if (name) parts.push(`Name: ${name}`);
  if (course) parts.push(`Course: ${course}`);
  if (date) parts.push(`Preferred Date: ${date}`);
  if (time) parts.push(`Preferred Time: ${time}`);
  if (message) parts.push(`Message: ${message}`);
  window.open(`${WHATSAPP_URL}?text=${encodeURIComponent(parts.join('\n'))}`, '_blank');
};
